import AdsError from './AdsError.js'

export default class RelatedAdsError extends AdsError {}
